var _rect, _text, _g, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NewGenXpert",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2000,
    height: 600,
    fill: "none"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradNGX",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00cfff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0047ab",
      stopOpacity: 1
    }
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 280,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 220,
    fontWeight: "bold",
    fill: "url(#gradNGX)"
  }, "\n    NGX\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#00cfff",
    strokeWidth: 6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 280,
    x2: 250,
    y2: 280
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 230,
    x2: 70,
    y2: 280
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 280,
    r: 12,
    fill: "#00cfff"
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 250,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 100,
    fill: "#0047ab"
  }, "\n    NewGenXpert\n  ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 520,
    y: 350,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 65,
    fill: "#7f8c9a"
  }, "\n    Empowering Tomorrow's Intelligence!\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo3.08bf6a1440e5b042da99afc5ad815c5a.svg";
export { ForwardRef as ReactComponent };